<template>
  <div :class="classList">
    <router-link
      to=""
      v-if="blockUser"
      @click.native="$emit('unBlockUser')"
      class="btn btn--static-md btn--green"
    >
      <icon name="user-pass-icon-2" />
      <span> שחרור מנעילה</span>
    </router-link>
    <router-link
      to=""
      v-else
      class="btn btn--static-md btn--red"
      @click.native="$emit('blockUser')"
    >
      <icon name="user-pass-icon-2" />
      <span>חסימת גישה</span>
    </router-link>
    <div class="sep-line mx-4"></div>
    <router-link
      to=""
      class="btn btn--static-md btn--blue"
      @click.native="$emit('changePasswordModal')"
    >
      <icon name="user-change-password" />
      <span>שינוי סיסמה</span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'UserControls',
  props: {
    blockUser: {
      type: Boolean,
      default: false
    },
    classList: {
      type: String,
      default: ''
    }
  }
};
</script>
